import { render, staticRenderFns } from "./proReviewDxPivot.vue?vue&type=template&id=3c3bfe94&scoped=true&"
import script from "./proReviewDxPivot.vue?vue&type=script&lang=js&"
export * from "./proReviewDxPivot.vue?vue&type=script&lang=js&"
import style0 from "./proReviewDxPivot.vue?vue&type=style&index=0&id=3c3bfe94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3bfe94",
  null
  
)

export default component.exports